var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30469 1.53359C9.30469 1.20222 9.57332 0.933594 9.90469 0.933594H13.9956C14.327 0.933594 14.5956 1.20222 14.5956 1.53359V5.6245C14.5956 5.95587 14.327 6.2245 13.9956 6.2245C13.6642 6.2245 13.3956 5.95587 13.3956 5.6245V2.13359H9.90469C9.57332 2.13359 9.30469 1.86496 9.30469 1.53359Z",
    fill: "#1A181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4255 1.10933C14.6599 1.34364 14.6599 1.72354 14.4255 1.95786L9.51645 6.86695C9.28214 7.10126 8.90224 7.10126 8.66792 6.86695C8.43361 6.63263 8.43361 6.25273 8.66792 6.01842L13.577 1.10933C13.8113 0.875015 14.1912 0.875015 14.4255 1.10933Z",
    fill: "#1A181E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.59844 4.31719H6.90753C7.2389 4.31719 7.50753 4.04856 7.50753 3.71719C7.50753 3.38582 7.2389 3.11719 6.90753 3.11719H2.54389C2.2401 3.11719 1.94875 3.23787 1.73393 3.45268C1.51912 3.6675 1.39844 3.95885 1.39844 4.26264V12.9899C1.39844 13.2937 1.51912 13.5851 1.73393 13.7999C1.94875 14.0147 2.2401 14.1354 2.54389 14.1354H11.2712C11.575 14.1354 11.8663 14.0147 12.0811 13.7999C12.2959 13.5851 12.4166 13.2937 12.4166 12.9899V8.62628C12.4166 8.29491 12.148 8.02628 11.8166 8.02628C11.4852 8.02628 11.2166 8.29491 11.2166 8.62628V12.9354H2.59844V4.31719Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalBlack);
export default __webpack_public_path__ + "static/media/external-black.6d4b408fbba3c70b5b3e979d22ec9e29.svg";
export { ForwardRef as ReactComponent };